import React, { FC } from 'react';
import Modal from './common/Modal/Modal';

interface ModalDifferentIdProps {
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalDifferentId: FC<ModalDifferentIdProps> = ({
  isShow,
  onRequestClose,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title="Wallet connection failure"
      onClose={onRequestClose}
      explanation="The wallet address connected to the To chain does not match. Please check your KSTADIUM account and enter it again."
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalDifferentId;
